// Domain types for client contacts.
export interface Contact {
  id: string;
  name: string;
  title?: string;
  email?: string;
  phone?: string;
}

export interface ContactFormValues {
  name: string;
  title: string;
  email: string;
  phone: string;
}

export const emptyContactForm: ContactFormValues = {
  name: "",
  title: "",
  email: "",
  phone: "",
};
